export default {"src":"/_next/static/media/logo-orange.05a39179.svg","height":44,"width":68};